import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketnotificationService {
  public socket: WebSocket | undefined;
  private connectionStatus: boolean = false;
  port = environment.port;
  constructor() {
    this.connectWebSocket();
  }

  public connectWebSocket(): void {
    // Establish WebSocket connection
    let additionalParam = localStorage.getItem('schema_name');
    let additionalParam1 = localStorage.getItem('org_domain');
    let additionalParam2 = localStorage.getItem('notifId');
    let additionalParam3 = Number(additionalParam2);
    
    if (additionalParam1 === null) {
        // Handle the case where 'org_domain' is null
        console.error('org_domain is null');
        return;
    }

    const url = new URL(additionalParam1);
    const hostname = url.hostname; // Extracting just the hostname

    this.socket = new WebSocket(`wss://${hostname}:${this.port}/ws/notification-count/${additionalParam3}/${additionalParam}/`);
    
    // Set up connection status listener
    this.socket.onopen = () => {
        this.connectionStatus = true;
        console.log('WebSocket Connection statusnnnorig:', this.connectionStatus);
    };

    // Set up disconnection status listener
    this.socket.onclose = () => {
        this.connectionStatus = false;
        console.log('WebSocket Connection status:', this.connectionStatus);
    };
  }

  public receiveData(callback: (data: any) => void): void {
    if (!this.socket) {
      console.error('WebSocket connection is not established.');
      return;
    }

    this.socket.onmessage = (event) => {
      console.log(typeof(event.data),'event.datanoti')
      const data = JSON.parse(event.data);
      console.log('this.datanoti',data);
      console.log(typeof(data),'data')
      callback(data);
    };
  }
}
